import BlogDetails from ".";

export const blogsDetailsRoutes = () => [
  {
    path: "/blogDetail",
    component: BlogDetails,
    layout: "front",
    title: "page",
  },
];